'use strict';

(function () {
    /**
     * Проверка выхода контейнера за пределы безопасной зоны
     */
    const self = Fotobook.safeArea = {

        get enabled() {
            if (Fotobook.store.state.OnlineEditor.previewMode) {
                return false;
            }
            if (!this.getPages().length) {
                return false;
            }
            const editMode = Fotobook.store.getters['OnlineEditor/editMode'];
            if (!editMode || editMode.code === Fotobook.EditModeCode.INSTANT) {
                return false;
            }
            return Fotobook.store.getters['OnlineEditor/safeAreaMode'];
        },
        safeAreas: {},
        $safeAreaHolder: null,
        isSpreadContent: false,
        currentContainer: null,
        jitterTimer: null,

        getPages() {
            return $(Fotobook.book.book).find('.book-page').not('.flyleaf-page');
        },

        /** process checking */
        check() {
            if (!this.enabled) {
                return;
            }

            const book = $(Fotobook.book.book);
            let selector = '.page-container:not(.group-container)';
            let showWarning = false;

            if (!Fotobook.config.data[Fotobook.Settings.SAFE_AREA_DETECT_ARTEFACT]) {
                selector += ':not(.artefact-container)';
            }
            if (!Fotobook.config.data[Fotobook.Settings.SAFE_AREA_DETECT_FOTO] && !Fotobook.config.data[Fotobook.Settings.SAFE_AREA_DETECT_FRAME]) {
                selector += ':not(.foto-container)';
            }
            if (!Fotobook.config.data[Fotobook.Settings.SAFE_AREA_DETECT_TEXT]) {
                selector += ':not(.text-container)';
            }

            const $safeAreaBorder = $('.safe-area-border');
            const $containers = book.find('.book-page').find(selector);
            if (!$containers.length) {
                $safeAreaBorder.each((index, sab) => {
                    const $sab = $(sab);
                    $sab.removeClass('intersect0 intersect1 intersect2 intersect3');
                });
                return;
            }

            this.safeAreas = {};
            $containers.each((index, container) => {
                const $this = $(container);
                const $frame = $this.find('.gfx-frame');
                let frameWidth = 0;
                let intersects = false;
                let containerCords;
                let w2;
                let h2;

                if (!Fotobook.config.data[Fotobook.Settings.SAFE_AREA_DETECT_FOTO] && $this.hasClass('foto-container') && !$frame.length) {
                    return;
                }

                if ($frame.length) {
                    frameWidth = $frame[0].width.baseVal.value;
                }

                if (Fotobook.config.data[Fotobook.Settings.SAFE_AREA_DETECT_FRAME] && frameWidth > $this.width()) {
                    w2 = frameWidth / 2;
                    h2 = $frame[0].height.baseVal.value / 2;
                    containerCords = $frame[0].getBoundingClientRect();
                } else {
                    w2 = $this.width() / 2;
                    h2 = $this.height() / 2;
                    containerCords = $this[0].getBoundingClientRect();
                }
                let contCoordinates = [];
                const angle = Fotobook.book.getContainerRealAngle($this);
                if (angle) {
                    const cx = containerCords.left + containerCords.width / 2;
                    const cy = containerCords.top + containerCords.height / 2;
                    const m = Fotobook.book.getRotationMatrix(angle);
                    contCoordinates = [-w2, -h2, w2, -h2, w2, h2, -w2, h2];

                    for (let i = 0; i < contCoordinates.length; i += 2) {
                        const point = Fotobook.book.matrix_transform(m, contCoordinates[i], contCoordinates[i + 1]);
                        contCoordinates[i] = point.x + cx;
                        contCoordinates[i + 1] = point.y + cy;
                    }
                }

                this.currentContainer = $this;
                const $safeAreaBoxes = $this.parents('.overflow-limiter, .pages-wrapper').find('.safe-area-box');
                if ($safeAreaBoxes.length) {
                    $safeAreaBoxes.each((index, value) => {
                        const safeAreaBox = $(value)[0];
                        if (Fotobook.book.product.pages_spread_count > 1 && !Fotobook.safeArea.isSpreadContent) {
                            if ($(Fotobook.safeArea.currentContainer).parents('.book-page')[0] !== $(safeAreaBox).parents('.book-page')[0]) {
                                return; // контейнер расположен на другой странице
                            }
                        }

                        const $safeAreaBorder = $(safeAreaBox).parent('.safe-area-border');
                        const objKey = 'sa' + $safeAreaBorder.data('id');
                        if (!this.safeAreas[objKey]) {
                            this.safeAreas[objKey] = [0, 0, 0, 0]; // битовая маска пересечения сторон
                        }
                        const containerOwnerCords = safeAreaBox.getBoundingClientRect();

                        if (!angle) {
                            const belongs = Fotobook.rectsIntersect.intersected($safeAreaBorder[0].getBoundingClientRect(), containerCords);
                            const crossedBorders = Fotobook.rectsIntersect.getCrossedBorders(containerOwnerCords, containerCords);
                            crossedBorders.map((val, index) => {
                                if (belongs) {
                                    this.safeAreas[objKey][index] = this.safeAreas[objKey][index] || val;
                                }
                            });
                        } else {
                            for (let $i = 0; $i <= 3; $i++) { // safe area sides
                                if (this.safeAreas[objKey][$i] === 1) {
                                    continue;
                                }
                                let saSegmentCords;
                                const cOC = containerOwnerCords;
                                switch ($i) {
                                    case 0:
                                        saSegmentCords = [cOC.x, cOC.y, cOC.x + cOC.width, cOC.y];
                                        break;
                                    case 1:
                                        saSegmentCords = [cOC.x + cOC.width, cOC.y, cOC.x + cOC.width, cOC.y + cOC.height];
                                        break;
                                    case 2:
                                        saSegmentCords = [cOC.x + cOC.width, cOC.y + cOC.height, cOC.x, cOC.y + cOC.height];
                                        break;
                                    case 3:
                                        saSegmentCords = [cOC.x, cOC.y + cOC.height, cOC.x, cOC.y];
                                }

                                for (let $k = 0; $k <= 3; $k++) { // container sides
                                    let contSegmentCords;
                                    const cC = contCoordinates;
                                    switch ($k) {
                                        case 0:
                                            contSegmentCords = [cC[0], cC[1], cC[2], cC[3]];
                                            break;
                                        case 1:
                                            contSegmentCords = [cC[2], cC[3], cC[4], cC[5]];
                                            break;
                                        case 2:
                                            contSegmentCords = [cC[4], cC[5], cC[6], cC[7]];
                                            break;
                                        case 3:
                                            contSegmentCords = [cC[6], cC[7], cC[0], cC[1]];
                                    }
                                    // пересечение ?
                                    if (Fotobook.rectsIntersect.intersectedSegments(saSegmentCords, contSegmentCords)) {
                                        this.safeAreas[objKey][$i] = 1;
                                        break;
                                    }
                                }
                            }
                        }
                    });
                }

                if (!intersects) {
                    $this.removeClass('safe-area-detected');
                }
            });

            $safeAreaBorder.each((index, sab) => {
                const $sab = $(sab);
                $sab.removeClass('intersect0 intersect1 intersect2 intersect3');
                const objKey = 'sa' + $sab.data('id');
                if (this.safeAreas[objKey] === undefined) {
                    return;
                }
                this.safeAreas[objKey].map((val, index) => {
                    if (val) {
                        showWarning = true;
                        $sab.addClass(`intersect${index}`);
                    }
                });
            });

            if (showWarning && !$('html').hasClass('toggle-pages-list-outer')) {
                Fotobook.notification.showWarning(t('photobook-js-safeArea-warning'));
            }
        },

        rebuild() {
            if (!this.enabled) {
                return;
            }

            if (Fotobook.safeArea.jitterTimer) {
                clearTimeout(Fotobook.safeArea.jitterTimer);
            }
            Fotobook.safeArea.jitterTimer = setTimeout(() => {
                self.rebuildByTimer();
                Fotobook.safeArea.jitterTimer = null;
            }, 500);
        },

        recalcFoldSafeArea(safeAreaSize, safeAreaInnerSize) {
            const foldsPositions = Fotobook.editor.fold.getFoldsOffsets();
            foldsPositions.unshift(0);

            // @todo check this sorting
            foldsPositions.sort();
            let counter = 1;
            const $safeAreaBorders = $('.safe-area-border');
            $safeAreaBorders.each((index, border) => {
                const $border = $(border);
                const nextVal = typeof foldsPositions[index + 1] !== 'undefined' ? foldsPositions[index + 1] : 100;
                let currentFoldPosition = foldsPositions[index];
                const width = nextVal - currentFoldPosition;

                const css = {
                    left: `${currentFoldPosition}%`,
                    width: `${width}%`,
                    'border-width': safeAreaSize,
                };


                if ($safeAreaBorders.length >= 2 && counter === 1) {
                    css['border-right-width'] = safeAreaInnerSize;
                } else if ($safeAreaBorders.length >= 2 && counter === $safeAreaBorders.length) {
                    css['border-left-width'] = safeAreaInnerSize;
                } else {
                    Object.assign(css, {
                        'border-left-width': safeAreaInnerSize,
                        'border-right-width': safeAreaInnerSize,
                    });
                }
                $border.css(css);
                counter++;
            });
        },

        // доп ширина для исключения корешка при определенных условиях
        getSpineSize($holder) {
            const size = {
                height: 0,
                width: 0,
            };
            if (!Fotobook.book.bookbind) {
                return size;
            }
            const verticalBookbind = Fotobook.book.isVerticalBookbind();
            if (!Fotobook.book.single_page_mode && !this.isSpreadContent && $holder.hasClass('page_even') && $holder.hasClass('cover')) {
                const spineSize = Fotobook.book.getClearSize(Fotobook.book.getSpineThickness());
                if (verticalBookbind) {
                    size.width += spineSize;
                } else {
                    size.height += spineSize;
                }
            }
            return size;
        },

        recalcBookSafeArea(safeAreaSize, safeAreaInnerSize) {
            const $safeAreaBorders = $('.safe-area-border');
            let id = 0;
            $safeAreaBorders.each((index, border) => {
                const $border = $(border);
                const $holder = $border.closest(Fotobook.safeArea.$safeAreaHolder);
                const spineSize = this.getSpineSize($holder);
                // Через Fotobook.book.pxToEm считает неправильно
                const fontSize = parseFloat($border.css('font-size'));
                const width = ($holder.outerWidth(true) / fontSize -spineSize.width) + 'em';
                const height = ($holder.outerHeight(true) / fontSize - spineSize.height) + 'em';
                const left = $holder.position().left / fontSize + 'em';
                const top = $holder.position().top / fontSize + 'em';

                $border
                    .css({
                        'border-width': safeAreaSize,
                        width,
                        height,
                        left,
                        top,
                    })
                    .attr('data-id', id++);
                // зона возле корешка
                if (!this.isSpreadContent) {
                    let borderWidthProp = '';
                    if (Fotobook.book.single_page_mode) {
                        switch (Fotobook.book.product.has_bookbind) {
                            case Fotobook.BookbindPosition.RIGHT:
                                borderWidthProp = 'border-right-width';
                                break;
                            case Fotobook.BookbindPosition.TOP:
                                borderWidthProp = 'border-top-width';
                                break;
                            case Fotobook.BookbindPosition.LEFT:
                                borderWidthProp = 'border-left-width';
                                break;
                        }
                    } else {
                        borderWidthProp = 'border-right-width';
                        if ($holder.hasClass('page_odd')) {
                            borderWidthProp = 'border-left-width';
                        }
                    }

                    if (borderWidthProp) {
                        $border.css(borderWidthProp, safeAreaInnerSize);
                    }
                }
            });
        },

        /** rebuild html structures */
        rebuildByTimer() {
            const $page = this.getPages();
            const region = $page.attr('data-page_type');
            const isCover = region === Fotobook.PageType.COVER;
            const displayRegion = Fotobook.displayRegions.getRegion(region);
            this.isSpreadContent = Fotobook.book.product.pages_spread_count > 1 ? (isCover ? Fotobook.book.bookbind.cover_spread_content : Fotobook.book.bookbind.spread_content) : false;
            const safeAreaInner = this.isSpreadContent ? 0 : displayRegion.art_box.safe_area_inner;
            const safeAreaSize = Fotobook.book.getSizeInEm(displayRegion.art_box.safe_area, 1);
            const safeAreaInnerSize = Fotobook.book.getSizeInEm(safeAreaInner, 1);

            this.injectSafeAreaBox(this.isSpreadContent);

            // несколько зон для листовой продукции
            if (Fotobook.book.product.fold_orientation) {
                this.recalcFoldSafeArea(safeAreaSize, safeAreaInnerSize);
            } else {
                this.recalcBookSafeArea(safeAreaSize, safeAreaInnerSize);
            }

            //линии прилипания для безопасной зоны
            $('.safe-area-box').each(function () {
                Fotobook.draggable.buildBorderLines($(this));
            });
            this.check();
        },

        processSafeAreaButton() {
            $(':root').toggleClass('safe-area-enabled', this.enabled);
            this.rebuild();
        },

        /** Подсчитываем кол-во областей безопасных зон и внедряем их в верстку */
        injectSafeAreaBox(isSpreadContent) {
            $('.safe-area-border').remove();
            let repeat = 1;
            this.$safeAreaHolder = this.getPages();

            if (Fotobook.book.product.fold_orientation) {
                repeat = Fotobook.editor.fold.getFoldsOffsets().length + 1;
            } else if (isSpreadContent) {
                this.$safeAreaHolder = this.$safeAreaHolder.closest('.pages-wrapper');
            }

            $(this.$safeAreaHolder)
                .append(`
                    <div class="safe-area-border" >
                        <div class="safe-area-box"></div>
                    </div>
                `.repeat(repeat));
        },
    };

    $(document)
        .on(Fotobook.events.SWITCH_EDIT_MODE, () => Fotobook.safeArea.processSafeAreaButton())
        .on(Fotobook.events.ONLINE_EDITOR_STARTED, () => Fotobook.safeArea.processSafeAreaButton())
        .on(Fotobook.events.CHANGE_PAGE, () => Fotobook.safeArea.rebuild())
        .on(Fotobook.events.CONTAINER_ADDED, () => Fotobook.safeArea.check())
        .on(Fotobook.events.PROJECT_CONTENT_CHANGED, () => Fotobook.safeArea.check())
    ;
})();
